import { defineStyleConfig } from '@chakra-ui/react'

import { inputTheme } from './input'

export const numberInputTheme = defineStyleConfig({
  baseStyle: {
    field: {
      // Reuse input base style. May need to merge in future.
      ...inputTheme.baseStyle?.field,
    },
    root: {
      width: '100%',
    },
    stepperGroup: {
      flexDirection: 'row', //override from column
      width: 'auto', // override
      gap: '2px', //little space to match design
      alignItems: 'center', //make sure separator is vertically centered
    },
    stepper: {
      border: 'none', //override
      px: '10px',
      alignSelf: 'stretch', // fill vertical height
    },
  },
  variants: {
    outline: {
      ...inputTheme.variants?.outline,
    },
  },
  defaultProps: {
    variant: 'outline',
  },
})
